import apiService from './api';
import { cognitoUserManagerSettings } from '@/configs/cognitoAuthConfig';
import type {
  InvitationExchangeTokenApiResponse,
  InvitationExchangeTokenInputPayload,
  InvitationExchangeTokenPayload,
  InvitationExchangeTokenResponse,
} from '@/types';

class InvitationService {
  private readonly baseUrl = '/invitation';

  private getExchangeTokenErrorMessage = (data: InvitationExchangeTokenApiResponse): string => {
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      const messages = data.errors
        .flatMap((e) => (Array.isArray(e.messages) ? e.messages : []))
        .map((m) => String(m).trim())
        .filter(Boolean);

      if (messages.length > 0) {
        return Array.from(new Set(messages)).join('\n');
      }
    }

    return String(data.message || data.detail || 'Token exchange failed');
  };

  exchangeToken = async ({
    inviteId,
    ott,
    userName,
    publicToken,
  }: InvitationExchangeTokenInputPayload): Promise<InvitationExchangeTokenResponse> => {
    try {
      const payload: InvitationExchangeTokenPayload = {
        ott,
        userName,
        clientId: cognitoUserManagerSettings.client_id,
      };

      const response = await apiService.post<InvitationExchangeTokenApiResponse>(
        `${this.baseUrl}/${inviteId}/exchange-token`,
        payload,
        {
          headers: {
            'X-PUBLIC-TOKEN': publicToken,
          },
        }
      );
      const data = response.data;

      if (Array.isArray(data.errors) && data.errors.length > 0) {
        throw new Error(this.getExchangeTokenErrorMessage(data));
      }

      if (!data.accessToken?.trim()) {
        throw new Error(this.getExchangeTokenErrorMessage(data));
      }

      return { accessToken: data.accessToken };
    } catch (e) {
      console.error('Error exchanging invitation token:', e);
      throw e;
    }
  };
}

export default new InvitationService();
